import { createApi } from '@reduxjs/toolkit/query/react'
import { AxiosResponse } from 'axios'
import { IUser, WingLoginResponse, UserPassPayload } from '../../interfaces/auth/IUser'
import { authAxiosQuery } from '../../utils/axios/auth.axios'
import { readFromStorage } from '../../utils/webStorage'
import { ISignUpUser } from '../../interfaces/auth/ISignUpUser'

export const authApi = createApi({
    reducerPath: 'auth',
    baseQuery: authAxiosQuery(),
    endpoints: (builder) => ({
        login: builder.mutation<WingLoginResponse, UserPassPayload>({
            query: (payload) => ({
                url: '/dom/login',
                method: 'POST',
                data: payload
            })
        }),
		signUp: builder.mutation<WingLoginResponse, ISignUpUser>({
            query: (payload) => ({
                url: '/dom/hotelworld/create-user',
                method: 'POST',
                data: payload
            })
        }),
        currentUser: builder.query<AxiosResponse<IUser>, {}>({
            query: (payload) => ({
                url: '/dom/authorize',
                method: 'POST',
                data: payload,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${readFromStorage('accessToken')}`,
                },
            })
        }),
        refreshToken: builder.mutation<WingLoginResponse, string>({
            query: (token) => ({
                url: '/outlook/refresh-token',
                method: 'POST',
                data: { token },
            })
        }),
    }),
})

export const {
    useLoginMutation,
	useSignUpMutation,
    useCurrentUserQuery,
    useRefreshTokenMutation
} = authApi